import React, {Component} from 'react';

class Promotion extends Component {
    render() {
        return (
            <div>
                <div className="my-4 text-center">
                    <h2 className="md:text-6xl text-5xl font-bold drop-shadow-md bg-gradient-to-r from-blue-500 to-blue-800 inline-block text-transparent uppercase bg-clip-text">Über mich</h2>
                    <p className="text-gray-500 text-center font-bold">Lebensdaten und weiteres!</p>
                </div>

                <div className="container promotion-overlay mx-auto mt-auto bg-white border-2 border-gray-200 rounded-3xl shadow-lg">
                    <div className="flex flex-col min-[800px]:flex-row justify-center items-center p-12 bottom-1/4">

                        <span className="md:mr-12 text-3xl text-black text-center p-5">
                            <div className="my-4 text-center">
                                <h2 className="text-6xl font-bold text-gray-700">
                                    Ulrich Schulze
                                </h2>
                            </div>
                            <div className="text-justify text-lg text-gray-700">
                                <p>Jahrgang 1969; Studium der Rechtswissenschaften an der</p>
                                <p>Universität Bielefeld; Referendariat am Landgericht Kassel;</p>
                                <p>selbstständiger Rechtsanwalt mit dem Tätigkeitsschwerpunkt</p>
                                <p>Individual- und Kollektivarbeitsrecht; umfangreiche</p>
                                <p>forensische Erfahrung (Urteils- und Beschlussverfahren sowie</p>
                                <p>Einigungsstellen); Referent, Gutachter und Berater;</p>
                                <p>mehrjährige Tätigkeit als angestellter Referent für Arbeits-</p>
                                <p>und Betriebsverfassungsrecht bei einem Bildungsinstitut für</p>
                                <p>Betriebsräte und Führungskräfte; Weiterqualifizierung zum</p>
                                <p>Personalreferenten; Tätigkeit als Personalreferent bei einem</p>
                                <p>Postunternehmen.</p>
                            </div>
                        </span>

                        <div className="flex w-1/4 max-[800px]:w-3/4 max-[800px]:pt-12 drop-shadow-lg">
                            <img
                                src="https://i.imgur.com/pjlLudx.png"
                                alt="promotion logo"
                                className="p-5 max-w-full mx-auto rounded-[40px] bg-slate-100 border-2 border-gray-200%"
                            />
                        </div>
                    </div>
                </div>


            </div>
        );
    }
}

export default Promotion;